let pathCache = {};
let relationships = [];
let roots = [];
function add(rel) {
  relationships = Object.freeze([...relationships, rel]);
  pathCache = Object.freeze({
    ...pathCache,
    [rel.path]: rel
  });
  if (rel.path.indexOf('.') < 0) {
    // this is a root. add it to the list
    roots = Object.freeze([...roots, rel]);
  }
}
function clear() {
  relationships = Object.freeze([]);
  pathCache = Object.freeze({});
  roots = Object.freeze([]);
}
function getByPath(path) {
  return pathCache[path];
}
function getChildByPath(rel, childPath) {
  return pathCache[`${rel.path}.${childPath}`];
}
function getAllByPath() {
  return pathCache;
}
function getAll() {
  return relationships;
}
function getRoots() {
  return roots;
}
export default {
  add,
  getByPath,
  getChildByPath,
  getAllByPath,
  getAll,
  getRoots,
  clear
};